import { AiOutlineGithub, AiOutlineHtml5 } from "react-icons/ai";
import { FaCss3Alt, FaSass, FaReact, FaNodeJs, FaPython } from "react-icons/fa";
import { BsBootstrap } from "react-icons/bs";

import { SiMui, SiTailwindcss } from "react-icons/si";
import { DiJavascript1, DiMongodb } from "react-icons/di";

export const skillsData = [
  {
    skill: "GIT",
    icon: <AiOutlineGithub size={24} />,
  },
  {
    skill: "HTML",
    icon: <AiOutlineHtml5 size={24} />,
  },
  {
    skill: "CSS",
    icon: <FaCss3Alt size={24} />,
  },
  {
    skill: "Sass",
    icon: <FaSass size={24} />,
  },
  {
    skill: "Bootstrap",
    icon: <BsBootstrap size={24} />,
  },
  {
    skill: "Tailwind CSS",
    icon: <SiTailwindcss size={24} />,
  },
  {
    skill: "Material UI",
    icon: <SiMui size={24} />,
  },
  {
    skill: "JavaScript",
    icon: <DiJavascript1 size={24} />,
  },
  {
    skill: "React",
    icon: <FaReact size={24} />,
  },
  {
    skill: "Node.js",
    icon: <FaNodeJs size={24} />,
  },
  {
    skill: "MongoDB",
    icon: <DiMongodb size={24} />,
  },
  {
    skill: "Python",
    icon: <FaPython size={24} />,
  },
];
